// extracted by mini-css-extract-plugin
export default {"wrap":"OrdersCounterModal_wrap__2Tmsh","btn":"OrdersCounterModal_btn__fqbeZ","state":"OrdersCounterModal_state__5bDwh","icon":"OrdersCounterModal_icon__v6Fpz"};